import Amplify, { API, graphqlOperation, Auth } from "aws-amplify";
import awsconfig from "../aws-exports";
import {
  customerResponsesByCodeBase,
  customerResponsesByPartyID,
  agentResponsesByForm,
} from "../graphql/queries";
import { onCreateAgentResponse } from "../graphql/subscriptions";

Amplify.configure(awsconfig);
Amplify.configure({
  API: {
    graphql_headers: async () => {
      const session = await Auth.currentSession();
      return {
        Authorization: session.getIdToken().getJwtToken(),
      };
    },
  },
});

/**
 * sortDirection = DESC has been added for pre LAN-110 traveller entries that are duplicate
 * because the traveller filled the form multiple times. The sortDirection has been added to fetch the latest entry.
 */
export const getCustomer = (base = null) => {
  return API.graphql(
    graphqlOperation(customerResponsesByCodeBase, {
      QRCodeBase: base,
      sortDirection: "DESC",
    })
  );
};

/**
 * The QR Codes are generated from QRCodeBase attribute.
 * This function is required to "search" (and not scan) for the latest entry in case the passenger filled multiple forms.
 * When doing a search, we generate the hash based on the 4 search fields (which is stored in PartyID)
 * @param {*} base: hash of arrival date + passport number + DOB + passport country of issuance.
 * @param {*} getLatestOnly
 * @returns
 */
export const getCustomerByPartyID = (base = null, getLatestOnly = false) => {
  return API.graphql(
    graphqlOperation(customerResponsesByPartyID, {
      PartyID: base,
      sortDirection: "DESC",
      limit: getLatestOnly ? 1 : 100,
    })
  );
};

export const getLogsByCodebase = (base = null) => {
  return API.graphql(
    graphqlOperation(agentResponsesByForm, {
      filter: {
        action: {
          ne: "Log",
        },
      },
      QRCodeBase: base,
    })
  );
};

export const subscribeToLogChanges = (codeBase: string) => {
  return API.graphql(graphqlOperation(onCreateAgentResponse))
    .map((value) => value.value.data.onCreateAgentResponse)
    .filter((value) => value.QRCodeBase === codeBase);
};
